import catalog from './epsgCatalog.json';

const systemsByCode = new Map(catalog.systems.map(system => [system.code, system]));

export const isEpsgTransform = process => process && process.Name === 'TransformEPSG';

export const readEpsgSettings = parameters => {
    const values = { sourceEpsg: '', targetEpsg: '', targetHeight: 'preserve' };
    (parameters || '').split(';').forEach(part => {
        const [key, value] = part.trim().split('=');
        if (Object.prototype.hasOwnProperty.call(values, key)) values[key] = (value || '').trim();
    });
    return values;
};

export const writeEpsgSettings = values =>
    `sourceEpsg=${values.sourceEpsg};targetEpsg=${values.targetEpsg}${values.targetHeight && values.targetHeight !== 'preserve' ? `;targetHeight=${values.targetHeight}` : ''}`;

export const validateEpsgSettings = parameters => {
    const values = readEpsgSettings(parameters);
    const valid = value => /^(EPSG:)?[1-9][0-9]{0,7}$/i.test(value.trim());
    if (!valid(values.sourceEpsg)) return 'Enter the source UTM EPSG code, including the correct datum and zone.';
    if (!valid(values.targetEpsg)) return 'Enter the destination EPSG code.';
    if (!['preserve', 'ahd'].includes(values.targetHeight)) return 'Choose a supported output height setting.';
    if (values.targetHeight === 'ahd') {
        const system = systemsByCode.get(values.targetEpsg.replace(/^EPSG:/i, ''));
        if (!system || !system.ahd) return 'AHD needs a geographic or projected horizontal CRS. Geocentric XYZ has no independent height axis.';
    }
    return '';
};

// UTM identifies a projection, not the datum supplied by a GNSS correction service.
export const epsgNotice = values => {
    const code = value => Number((value || '').replace(/^EPSG:/i, ''));
    const source = code(values.sourceEpsg), target = code(values.targetEpsg);
    if (values.targetHeight === 'ahd' && systemsByCode.get(String(target)) && !systemsByCode.get(String(target)).ahd) return 'Geocentric XYZ has no separate height axis. Select a geographic or projected destination to use AHD.';
    if (values.targetHeight === 'ahd') return 'AUSGeoid2020 converts source ellipsoidal heights to AHD (EPSG:5711). The correction varies across the map. Do not select this for source heights already in AHD. AHD can accompany any compatible horizontal EPSG; it replaces any height definition in the destination CRS. Geocentric XYZ cannot use AHD as its Z axis.';
    if (source && source === target) return 'Source and destination are the same CRS. Coordinates will stay unchanged; the output LAS will carry the selected EPSG metadata.';
    if (source >= 32748 && source <= 32758 && target === source - 24900)
        return 'WGS 84 to GDA2020 in the same UTM zone can produce virtually no coordinate shift (the default datum approximation has 3 m accuracy). If your GPS corrections already use GDA2020, choose the matching GDA2020 / MGA source EPSG. A precise WGS 84 datum correction needs the reference frame and coordinate epoch.';
    return '';
};
